import { useMemo } from "react";

import type { DragonTile, InnerTile } from "@/types/dragon-tiles";

import { getAudienceId } from "@/features/DragonTiles/audienceInnerTiles";
import { ParentTileViewStore } from "@/features/DragonTiles/store/parentTileView";

export function resolveActiveInnerTile(
  dragonTile: DragonTile,
  selectedAudienceId: string | null,
): InnerTile | null {
  if (selectedAudienceId) {
    const match = dragonTile.inner_tiles.find(
      (it) => getAudienceId(it) === selectedAudienceId,
    );
    if (match) return match;
  }

  const defaultTile = dragonTile.inner_tiles.find((it) => !getAudienceId(it));
  return defaultTile ?? dragonTile.inner_tiles[0] ?? null;
}

export function useSelectedInnerTile(dragonTile: DragonTile): InnerTile | null {
  const selectedAudienceId = ParentTileViewStore.useSelectedAudienceId();
  return useMemo(
    () => resolveActiveInnerTile(dragonTile, selectedAudienceId),
    [dragonTile, selectedAudienceId],
  );
}
